import { render, staticRenderFns } from "./SimpleParagraph.vue?vue&type=template&id=44fab6cb&scoped=true&name=simple-paragraph&"
import script from "./SimpleParagraph.vue?vue&type=script&lang=js&"
export * from "./SimpleParagraph.vue?vue&type=script&lang=js&"
import style0 from "./SimpleParagraph.vue?vue&type=style&index=0&id=44fab6cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fab6cb",
  null
  
)

/* custom blocks */
import block0 from "./SimpleParagraph.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports